import styled from "styled-components";

export const Container = styled.div`
  max-width: 33.75rem;
  width: 100%;
  margin: 0 auto;
  height: 100vh;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;
